(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
  class LmLookBook extends HTMLElement {
    constructor() {
      super();
      this._items = Array.from(this.querySelectorAll('.lumin-lookbook-point-list-item'));
      this._items.forEach((elem) => this.handleTooltip(elem));

      // Close all when tapping anywhere outside the lookbook
      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) {
          this.closeAll();
        }
      });

      // Also close when tapping the image itself (not a button or tooltip)
      const inner = this.querySelector('.lumin-lookbook-inner');
      if (inner) {
        inner.addEventListener('click', (e) => {
          const clickedInsidePoint = e.target.closest('.lumin-lookbook-point-list-item');
          if (!clickedInsidePoint) {
            this.closeAll();
          }
        });
      }
    }

    closeAll(except) {
      this._items.forEach((elem) => {
        if (elem === except) return;
        const tooltip = elem.querySelector('.lm-tooltip');
        if (tooltip) this.instantHide(tooltip); // ← instant, no animation
      });
    }

    instantHide(tooltip) {
      tooltip.classList.remove('show', 'hiding');
      tooltip.style.display = 'none'; // force immediate hide
      // Reset display so future show works
      requestAnimationFrame(() => {
        tooltip.style.display = '';
      });
    }

    showTooltip(btn, tooltip) {
      // Close all others first
      this.closeAll(btn.closest('.lumin-lookbook-point-list-item'));
      tooltip.classList.remove('hiding');
      tooltip.classList.add('show');
      this.positionTooltip(btn, tooltip);
    }

    hideTooltip(tooltip) {
      tooltip.classList.remove('show');
      tooltip.classList.add('hiding');
      setTimeout(() => tooltip.classList.remove('hiding'), 200);
    }

    positionTooltip(btn, tooltip) {
      const inner = this.querySelector('.lumin-lookbook-inner');
      if (!inner) return;

      const innerRect = inner.getBoundingClientRect();
      const btnRect = btn.getBoundingClientRect();
      const tipW = tooltip.offsetWidth || 260;
      const tipH = tooltip.offsetHeight || 200;

      // Position relative to inner container
      let left = btnRect.left - innerRect.left + btnRect.width / 2;
      let top = btnRect.top - innerRect.top + btnRect.height / 2;

      // Flip horizontally if too close to right edge
      if (left + tipW > innerRect.width - 12) {
        left = left - tipW;
      }

      // Flip vertically if too close to bottom
      if (top + tipH > innerRect.height - 12) {
        top = top - tipH;
      }

      // Clamp to stay inside container
      left = Math.max(8, Math.min(left, innerRect.width - tipW - 8));
      top = Math.max(8, Math.min(top, innerRect.height - tipH - 8));

      tooltip.style.left = `${left}px`;
      tooltip.style.top = `${top}px`;
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button');
      const tooltip = elem.querySelector('.lm-tooltip');
      if (!btn || !tooltip) return;

      const isTouch = window.matchMedia('(pointer: coarse)').matches;

      if (isTouch) {
        btn.addEventListener('click', (e) => {
          e.stopPropagation(); // prevent inner closeAll from firing
          if (tooltip.classList.contains('show')) {
            this.hideTooltip(tooltip);
          } else {
            this.showTooltip(btn, tooltip);
          }
        });

        // Stop tooltip taps from bubbling to inner (except the "View product" link)
        tooltip.addEventListener('click', (e) => {
          if (!e.target.closest('a')) {
            e.stopPropagation();
          }
        });
      } else {
        elem.addEventListener('mouseenter', () => this.showTooltip(btn, tooltip));
        elem.addEventListener('mouseleave', () => this.hideTooltip(tooltip));
        btn.addEventListener('focus', () => this.showTooltip(btn, tooltip));
        btn.addEventListener('blur', () => {
          setTimeout(() => {
            if (!elem.contains(document.activeElement)) this.hideTooltip(tooltip);
          }, 100);
        });
      }
    }
  }

  customElements.define('lumin-lookbook', LmLookBook);

  } catch(e) { console.error(e); }
})();
})();
